import { FindAndReplace } from '../../types';

/**
 * Infers the total count of affected content from an object of multiple content ID lists
 * @param affectedContentIds
 */
const getUsageCount = (
  affectedContentIds: FindAndReplace.AffectedContentIds,
) => {
  return Object.values(affectedContentIds)
    .filter(Array.isArray)
    .reduce((sum, arr) => sum + arr.length, 0);
};

export default getUsageCount;
